<template>
    <v-content :style="{color:title}" v-if="userIsAuthenticated">
        <v-container>
            <v-row class="mb-5">
                <v-col cols="12">
                    <v-row>
                        <h1 :style="{color:mainColor}">Órdenes de compra</h1>
                    </v-row>
                </v-col>
                <v-col class="text-center" cols="12" v-if="onLoading">
                    <loading-circular/>
                </v-col>
            </v-row>
            <v-row  v-if="orders.length === 0 && !onLoading">
                <h3>No tienes órdenes de compra pendientes.</h3>
            </v-row>
            <v-row  v-else>
                <v-col cols="10" offset="1" v-for="(order, index) in orders" :key="index" class="mb-4">
                    <v-card :style="{color:title}" hover>
                        <v-container fluid style="cursor: default">
                            <v-row>
                                <v-col cols="4" class="pr-0">
                                    <v-card-title>
                                      <v-col cols="12" class="pa-0">
                                        <h4 class="mb-0">Orden Nro. {{order.orderId}}</h4>
                                      </v-col>
                                      <v-col cols="12" class="pa-0">
                                        <h5>{{order.type === 'pickup' ? 'Entregar en tienda' : 'Entregar a domicilio'}}</h5>
                                      </v-col>
                                      <v-col cols="12" class="pa-0">
                                        <div class="body-2">Creado en {{new Date(order.creationDate.seconds * 1e3).toString() | dateFilter}}</div>
                                      </v-col>
                                    </v-card-title>
                                </v-col>
                                <v-col cols="6" :style="border" class="pl-6">
                                    <v-row>
                                        <v-card-subtitle class="pb-0 pt-6">
                                            <h5>Items</h5>
                                        </v-card-subtitle>
                                    </v-row>
                                    <v-row>
                                        <v-col
                                            cols="2"
                                            v-for="(item, index) in order.items"
                                            :key="index"
                                        >
                                          <v-card flat>
                                            <v-img
                                            :src="item.imageUrl"
                                            eager
                                            />
                                          </v-card>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="2">
                                    <v-row>
                                      <template>
                                        <order-dialog :orderObj="order"/>
                                      </template>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-content>
</template>
<script>
import * as constants from '../../../constants.json'
import { mdiDeleteOutline } from '@mdi/js'

export default {
  data () {
    return {
      orders: [],
      deleteIcon: mdiDeleteOutline,
      // color: '#318ef4',
      mainColor: constants.MAINCOLOR,
      title: '#525252',
      border: 'border-left: 1px solid #e9eaed'

    }
  },

  watch: {
    /**
     * Fetching data if user is authenticated
     */
    async user (value) {
      // eslint-disable-next-line
      console.log('value', value)
      if (value === null || value === undefined) {
        this.$router.push('/')
      } else {
        await this.fetchData()
      }
    }
  },

  computed: {
    dialog () {
      return this.$store.getters.getOrderDialog
    },

    onLoading () {
      return this.$store.getters.getLoading
    },

    /**
     * Get user object.
     * @returns the user object.
     */
    user () {
      return this.$store.getters.getUser
    },

    /**
     * Verify if the user is autenticated.
     * @returns true if user is autenticated.
     */
    userIsAuthenticated () {
      return this.$store.getters.getUser !== null && this.$store.getters.getUser !== undefined
    }
  },

  /**
   * Create view and observe data
   */
  async created () {
    this.fetchData()
  },

  methods: {
    async fetchData () {
    // Load orders from database
      try {
        const user = this.$store.getters.getUser
        if (user) {
          let companyId = ''

          if (user.role === 'mega_administrator') {
            companyId = localStorage.companyId
          } else {
            const companyData = this.$store.getters.getCompanyData
            companyId = companyData.companyId
          }

          await this.$store.dispatch('actionLoadOrders', companyId)
          this.orders = this.$store.getters.getLoadedOrders
          // eslint-disable-next-line
          console.log('this.orders', this.orders)
        }
      } catch (error) {
        throw error
      }
    },

    openDialog () {
      this.$store.commit('mutationOrderDialog', true)
    }
  }
}
</script>
